import { type JSX, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

type ErxBonusLandingPageFaqDataItem = {
  details: (
    values: Record<string, (text?: ReactNode[]) => ReactElement>,
  ) => JSX.Element
  key: string
  summary: JSX.Element
}

export const ErxBonusLandingPageFaqDataV1: ErxBonusLandingPageFaqDataItem[] = [
  {
    details: (values) => (
      <FormattedMessage id="deErx.bonus.faq.amount.details" values={values} />
    ),
    key: '0-faq',
    summary: <FormattedMessage id="deErx.bonus.faq.amount.summary" />,
  },
  {
    details: (values) => (
      <FormattedMessage
        id="deErx.bonus.faq.howIsCalculated.details"
        values={values}
      />
    ),
    key: '1-faq',
    summary: <FormattedMessage id="deErx.bonus.faq.howIsCalculated.summary" />,
  },
  {
    details: (values) => (
      <FormattedMessage
        id="deErx.bonus.faq.copaymentFree.details"
        values={values}
      />
    ),
    key: '2-faq',
    summary: <FormattedMessage id="deErx.bonus.faq.copaymentFree.summary" />,
  },
  {
    details: (values) => (
      <FormattedMessage
        id="deErx.bonus.faq.copayment.details"
        values={values}
      />
    ),
    key: '3-faq',
    summary: <FormattedMessage id="deErx.bonus.faq.copayment.summary" />,
  },
  {
    details: (values) => (
      <FormattedMessage
        id="deErx.bonus.faq.priceDifference.details"
        values={values}
      />
    ),
    key: '4-faq',
    summary: <FormattedMessage id="deErx.bonus.faq.priceDifference.summary" />,
  },
  {
    details: (values) => (
      <FormattedMessage id="deErx.bonus.faq.redeem.details" values={values} />
    ),
    key: '5-faq',
    summary: <FormattedMessage id="deErx.bonus.faq.redeem.summary" />,
  },
  {
    details: (values) => (
      <FormattedMessage
        id="deErx.bonus.faq.privatePrescription.details"
        values={values}
      />
    ),
    key: '5-faq',
    summary: (
      <FormattedMessage id="deErx.bonus.faq.privatePrescription.summary" />
    ),
  },
]
